<agpr-panel
    [id]="id"
    header="AMT.broadcast"
    [paddingBottom]="0"
    [marginTop]="20"
>
    <div class="agpr-flex-container">
        <agpr-checkbox
            [id]="id + '_tvEyes_checkbox'"
            [binary]="true"
            [disabled]="isReadOnly"
            label="AMT.broadcast.tvEyes"
            [(ngModel)]="licenses[licensesEnum.TVEYES]"
            (ngModelChange)="tvEyesToggle()"
        ></agpr-checkbox>

        @if (licenses[licensesEnum.TVEYES]) {
            <div class="agpr-tveyes-restrictions">
                <agpr-checkbox
                    [id]="id + '_tvEyes_archive_checkbox'"
                    class="agpr-tveyes-restrictions-provisioning"
                    [binary]="true"
                    label="AMT.broadcast.tvEyes.archiving"
                    [(ngModel)]="tvEyesArchiving"
                    (ngModelChange)="tvEyesOptionsChange()"
                ></agpr-checkbox>
                <agpr-checkbox
                    [id]="id + '_tvEyes_download_checkbox'"
                    class="agpr-tveyes-restrictions-provisioning"
                    [binary]="true"
                    label="AMT.broadcast.tvEyes.downloading"
                    [(ngModel)]="tvEyesDownloading"
                    (ngModelChange)="tvEyesOptionsChange()"
                ></agpr-checkbox>
                <div class="agpr-tveyes-restrictions-input">
                    <agpr-include-exclude-chips
                        [id]="id + '_accountManagement_tvEyesGeos'"
                        [(idModel)]="tvEyesGeos"
                        placeholder="AMT.broadcast.tvEyes.placeholder"
                        headerLabel="AMT.broadcast.tvEyes.restrictions"
                        [lookupById]="journodexRegionsService.getCountriesByIsoCode.bind(journodexRegionsService)"
                        idField="countryCode"
                        labelLookupField="name"
                        [disabled]="isReadOnly"
                        [autocompleteOptions]="{
                            suggestionsFetcher: journodexRegionsService.autoCompleteCountryWithCode.bind(journodexRegionsService)
                        }"
                        [showIncludeAll]="false"
                        (idModelChange)="tvEyesOptionsChange()"
                        headingLevel="4"
                        (browseAll)="showCountryBrowser($event)"
                    ></agpr-include-exclude-chips>
                </div>
            </div>
        }

        <agpr-checkbox
            [id]="id + '_refmedia_checkbox'"
            [infoCircleTooltip]="(account?.partnerResellerId === partnerResellerIds.refmedia || sublicenses[sublicensesEnum.REFMEDIA_BROADCAST]) ? '' : 'AMT.broadcats.refMedia_broadcast_not_enabled'"
            [binary]="true"
            [disabled]="!(account?.partnerResellerId === partnerResellerIds.refmedia) && !sublicenses[sublicensesEnum.REFMEDIA_BROADCAST]"
            label="AMT.broadcats.refMedia_broadcast"
            [(ngModel)]="sublicenses[sublicensesEnum.REFMEDIA_BROADCAST]"
            (onChange)="refMediaSublicenseChange()"
        ></agpr-checkbox>
    </div>
</agpr-panel>
